import styled from 'styled-components'

const ServiceHover = styled.div`
  position: relative;
  z-index: 2;
  grid-area: ${({ position }) => `service-${position}`};
`

export default ServiceHover
